import { useLearningObjectivesStore } from "store/modules/learningObjectivesStore";
import { ref, reactive } from "vue";
import { cloneDeep } from "lodash";
import { getWeekNumber } from "shared/utils/dateHelpers";
import { getCurrentSchoolYear } from "composables/useHelpers";

export const createDefaultManager = () => {
  const weeks = ref([]);
  const isInitialized = ref(false);
  const deltaState = reactive({});
  const showCurrentWeekIndicator = ref(true);

  const fetchAndSetWeeks = async ({
    schoolYear = getCurrentSchoolYear(),
    forceFetch = false,
  } = {}) => {
    const learningObjectivesStore = useLearningObjectivesStore();
    const { fetchWeeksBySchoolYear } = learningObjectivesStore;

    const fetchedWeeks = await fetchWeeksBySchoolYear({
      schoolYear,
      forceFetch,
    });

    weeks.value = cloneDeep(fetchedWeeks);

    const [currentWeek, currentYear] = getWeekNumber();

    const foundWeek = weeks.value.find(
      ({ week, year }) => week === currentWeek && year === currentYear,
    );

    if (foundWeek) {
      foundWeek.isCurrentWeek = true;
    }

    return weeks.value;
  };

  // Store initial values on drag start
  const startDelta = (model, deltaStart) => {
    if (!model) {
      throw new Error("Period not found");
    }

    const {
      id,
      planningMeta: { weekIndexes },
    } = model;

    deltaState[id] = {
      startWeekIndex: weekIndexes[0],
      endWeekIndex: weekIndexes[weekIndexes.length - 1],
      deltaStart,
    };
  };

  // Clear drag state after drag ends
  const endDelta = (modelId) => {
    delete deltaState[modelId];
  };

  return {
    weeks,
    isInitialized,
    deltaState,
    showCurrentWeekIndicator,
    fetchAndSetWeeks,
    startDelta,
    endDelta,
  };
};
